import { CardQuickActionButton } from './CardQuickActionButton';
import { EnlargeIcon, ExitFullScreenIcon } from 'foundations-assets';
import { useCallback } from 'react';
import I18n from 'I18n';
import { useUsageTracking } from 'crm-object-board-core/usageTracking';
import { useObjectTypeId } from 'crm-object-board-core/objectTypeDefinition';
import { useExpanderContext } from '../../hooks/useExpanderContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
export const ExpandActionButton = props => {
  const objectTypeId = useObjectTypeId();
  const {
    trackExpandClicked
  } = useUsageTracking();
  const {
    isExpanded,
    setIsExpanded,
    hasExpandableSections
  } = useExpanderContext();
  const handleCollapse = useCallback(() => {
    setIsExpanded(false);
  }, [setIsExpanded]);
  const handleExpand = useCallback(() => {
    // todo double check value here
    trackExpandClicked(objectTypeId, 'expand-action');
    setIsExpanded(true);
  }, [objectTypeId, trackExpandClicked, setIsExpanded]);
  if (!hasExpandableSections) {
    return null;
  }
  if (isExpanded) {
    return /*#__PURE__*/_createElement(CardQuickActionButton, Object.assign({}, props, {
      key: "collapse",
      action: "collapse",
      onClick: handleCollapse,
      "aria-label": I18n.text('crmObjectBoardCard.sections.collapse'),
      tooltip: I18n.text('crmObjectBoardCard.sections.collapse')
    }), /*#__PURE__*/_jsx(ExitFullScreenIcon, {}));
  }
  return /*#__PURE__*/_createElement(CardQuickActionButton, Object.assign({}, props, {
    key: "expand",
    action: "expand",
    onClick: handleExpand,
    "aria-label": I18n.text('crmObjectBoardCard.sections.expand'),
    tooltip: I18n.text('crmObjectBoardCard.sections.expand')
  }), /*#__PURE__*/_jsx(EnlargeIcon, {}));
};